var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-confirm" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showDiaUp,
            callback: function ($$v) {
              _vm.showDiaUp = $$v
            },
            expression: "showDiaUp",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _c("div", { staticClass: "btn" }, [
              _c("div", { staticClass: "two" }, [
                _c(
                  "span",
                  {
                    staticClass: "confirm-think",
                    on: { click: _vm.handleThinK },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lang.cfm.cancelBtn")) + " ")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "confirm-btn",
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lang.update")) + " ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }